import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

firebase.initializeApp({
  apiKey: "AIzaSyDVMoTVwAVWFDhlQ6-vOWNFXny6Ia5CWgA",
  authDomain: "portal-fdf7a.firebaseapp.com",
  databaseURL: "https://portal-fdf7a.firebaseio.com",
  projectId: "portal-fdf7a",
  storageBucket: "portal-fdf7a.appspot.com",
  messagingSenderId: "1062567198731",
  appId: "1:1062567198731:web:f797b9370525b3f1c2c70e",
});

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export { projectFirestore, projectStorage, projectAuth };
